/**
 * Display a toast showing an error message.
 * @param {Object} view     Vue view object.
 * @param {String} message
 */
function showErrorToast(view, message) {
  view.$bvToast.toast(message, {
    title: view.$t("error"),
    toaster: "b-toaster-top-right",
    solid: true,
    variant: "danger",
  });
}

/**
 * Display a toast showing a success message.
 * @param {Object} view     Vue view object.
 * @param {String} message
 * @param {String} title
 */
function showSuccessToast(view, message, title) {
  view.$bvToast.toast(message, {
    title: title || view.$t("success"),
    toaster: "b-toaster-top-right",
    solid: true,
    variant: "success",
  });
}

/**
 * Work out the text to display for a given CPD score.
 * This should be functionlly equivalent to utils/toolbox.ts in the api code.
 * @param {number}  cpdScore       The score to convert to text for displaying to the user.
 * @returns {string}
 */
function getCpdText(cpdScore) {
  // Work out hours and minutes
  let minutes = cpdScore % 60;
  if (minutes < 10) {
    minutes = `0${minutes}`;
  }
  const hours = Math.floor(cpdScore / 60);
  const cpdScoreTime = `${hours}:${minutes}`;

  // Generate text to display
  return cpdScoreTime;
}

/**
 * Update the CPD points in the store.
 * @param api
 * @param store
 */
async function updateCpdPoints(api, store) {
  if (store.state.user.logged_in && store.state.config.pdl_on) {
    await api
      .get("/api2/pdl/points")
      .then((response) => {
        store.commit("setCpd", response.data);
      })
      .catch(() => {});
  }
}

/**
 * Check that an uploaded file is valid.
 * Currently this is used when attaching files to a PDL record, but it could be modified for use elsewhere.
 * @param {File} file   The file selected for upload.
 * @param {Array} files The list of files already selected for upload.
 * @returns {Boolean}
 */
function fileIsValid(file, files) {
  const fileParts = file.name.split(".");
  const fileExtension = fileParts[fileParts.length - 1];
  return !(
    files.length >= 3 || // Allow a maximum of three attachments per record
    file.name.length > 64 || // Allow maximum file name lengths of 64 characters
    !file.name.match(/^[-\w. ]+$/g) || // Allow only alphanumeric, underscore, dash, space and dot in the filename
    file.size > 2097152 || // Allow a maximum file size of 2MB
    !["gif", "jpg", "jpeg", "png", "doc", "docx", "odt", "pdf", "xls", "xlsx", "txt"].includes(fileExtension)
  );
}

export { fileIsValid, showErrorToast, showSuccessToast, getCpdText, updateCpdPoints };
